import React from 'react';
import * as S from './TripTypeCard.styles';
import RadioButton from '../../../../../stories/core-components/CustomRadioButton/CustomRadioButton';
import {TripTypeConfig} from './../../../../containers/Review/Config'
const TripType = (props) => {
  const {tripType,onTripChange,businessInfo,onBusinessInfoChange} = props;
  return(
    <div>
      <S.TabContentInner>
        <S.TriptypeWrapper>
          {TripTypeConfig && TripTypeConfig.map(function (params,index) {
            return (    <RadioButton key={params.id+index} id={params.id} label={params.label} checked={params.id === tripType } onChangeCB={onTripChange}/>)
          })}
        </S.TriptypeWrapper>
      </S.TabContentInner>
     {tripType && tripType == "business" ? <S.BusinessForm>
        <S.FormRow>
          <S.FormInputWrap>
            <label>GST Number</label>
            <input type='text' spellCheck={false} className={businessInfo['gstNumberErr'] ? 'error':''} placeholder="EG: 22AAAAA0000A1Z5" maxLength={15} data-val="gstNumber" value={businessInfo['gstNumber']} onChange={onBusinessInfoChange} />
            {businessInfo['gstNumberErr'] ? <S.Error>{businessInfo['gstNumberErr'] || 'Enter GST Number'}</S.Error> :null}
          </S.FormInputWrap>
          <S.FormInputWrap>
            <label>Company Name</label>
            <input type='text' spellCheck={false} className={businessInfo['companyNameErr'] ? 'error':''} data-val="companyName"  value={businessInfo['companyName']} onChange={onBusinessInfoChange}/>
            {businessInfo['companyNameErr'] ? <S.Error>{businessInfo['companyNameErr'] || 'Enter Company Name'}</S.Error> :null}
          
          </S.FormInputWrap>
          <S.FormInputWrap>
            <label>Business Email</label>
            <input type='text'  spellCheck={false} className={businessInfo['businessMailErr'] ? 'error':''} placeholder="Business Email ID" data-val="businessMail"   value={businessInfo['businessMail']} onChange={onBusinessInfoChange}/>
            {businessInfo['businessMailErr'] ? <S.Error>{businessInfo['businessMailErr'] || 'Enter Business Email'}</S.Error> :null}
          
          </S.FormInputWrap>
        </S.FormRow>

        <S.FormRow>
          <S.FormInputWrap>
            <label>Company Address</label>
            <input type='text' spellCheck={false} className={businessInfo['companyAddressErr'] ? 'error':''}  data-val="companyAddress" value={businessInfo['companyAddress']} onChange={onBusinessInfoChange}/>
            {businessInfo['companyAddressErr'] ?      <S.Error>{businessInfo['companyAddressErr'] || 'Enter Company Name'}</S.Error>
        :null}
          
          </S.FormInputWrap>
        </S.FormRow>

        <S.FormRow>
          <S.FormInputWrap>
            <label>Phone Number</label>
            <input type='text' spellCheck={false} maxLength={businessInfo['contactNumberMaxLength']}className={businessInfo['phoneNumberErr'] ? 'error':''} data-val="phoneNumber" value={businessInfo['phoneNumber']} onChange={onBusinessInfoChange}/>
            {businessInfo['phoneNumberErr'] ? <S.Error> {businessInfo['phoneNumberErr'] || 'Enter Phone Number'}</S.Error> :null}
          
          </S.FormInputWrap>
          <S.FormInputWrap>
            <label>Country</label>
            <input type='text' spellCheck={false} className={businessInfo['countryErr'] ? 'error':''} data-val="country" value={businessInfo['country']} onChange={onBusinessInfoChange}/>
            {businessInfo['countryErr'] ? <S.Error>{businessInfo['countryErr'] || 'Enter Country'}</S.Error> :null}
          
          </S.FormInputWrap>
          <S.FormInputWrap>
            <label>State</label>
            <input type='text' spellCheck={false} className={businessInfo['stateErr'] ? 'error':''} data-val="state" value={businessInfo['state']} onChange={onBusinessInfoChange}/>
            {businessInfo['stateErr'] ? <S.Error>{businessInfo['stateErr'] || 'Enter State'}</S.Error> :null}
          
          </S.FormInputWrap>
        </S.FormRow>
        
      </S.BusinessForm> :null}
    </div>
);
    }
export default TripType;
